<template>
  <div class="blockC matching-box clearfix" style="margin-top: 20px">
    <div class="blockC-detail">
      <div class="blockC-tip"></div>
      <span class="blockC-title">船舶信息：</span>
    </div>
    <vxe-form
        style="margin-top: 10px;"
        ref="ship"
        class="my-form"
        title-align="right"
        :data="formData"
        :rules="formRules"
        title-width="120"
        prevent-submit>
      <vxe-form-item title="载重吨" field="deadweight" span="8">
        <template v-slot="scope">
          <vxe-input v-model="formData.deadweight" placeholder="必填" clearable
                     @input="$refs.ship.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="船籍港" field="homePort" span="8">
        <template v-slot="scope">
          <vxe-input v-model="formData.homePort" placeholder="选填" clearable
                     @input="$refs.ship.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="船舶种类" field="shipType" span="8">
        <template v-slot="scope">
          <vxe-input v-model="formData.shipType" placeholder="选填" clearable
                     @input="$refs.ship.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="船长/船宽(m)" field="shipLengthWidth" span="8">
        <template v-slot="scope">
          <vxe-input v-model="formData.shipLengthWidth" placeholder="选填" clearable
                     @input="$refs.ship.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="总吨/净吨" field="totalNetWeight" span="8">
        <template v-slot="scope">
          <vxe-input v-model="formData.totalNetWeight" placeholder="选填" clearable
                     @input="$refs.ship.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="满载吃水(m)" field="loadDraught" span="8">
        <template v-slot="scope">
          <vxe-input v-model="formData.loadDraught" placeholder="选填" clearable
                     @input="$refs.ship.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
    </vxe-form>
  </div>
</template>

<script>

  import $api from "@/apiProvider";

  export default {
    props: ['isSubmit', 'isCancel', 'isSave', 'detailData'],
    data() {
      return {
        formData: {
          deadweight: null,
          homePort: null,
          shipType: null,
          shipLengthWidth: null,
          totalNetWeight: null,
          loadDraught: null,
        },
        formRules: {
          deadweight: [{required: true, message: "请输入载重吨"}],
        },
      };
    },
    watch: {
      isSubmit(val) {
        if (val) {
          this.check();
        }
      },
      isCancel(val) {
        if (val) {
          this.reset();
        }
      },
      isSave(val) {
        if (val) {
          this.setParams();
        }
      },
      detailData(val) {
        if (val) {
          this.formData = {
            deadweight: this.detailData.deadweight,
            homePort: this.detailData.homePort,
            shipType: this.detailData.shipType,
            shipLengthWidth: this.detailData.shipLengthWidth,
            totalNetWeight: this.detailData.totalNetWeight,
            loadDraught: this.detailData.loadDraught,
          }
        }
      }
    },
    methods: {
      setShipInfo(row) {
        this.$set(this, 'formData', {
          deadweight: row.deadweight,
          shipType: row.shipType,
          homePort: null,
          shipLengthWidth: row.shipWidth ? row.shipLength + '/' + row.shipWidth : row.shipLength,
          totalNetWeight: row.netweight ? row.totalweight + '/' + row.netweight : row.totalweight,
          loadDraught: row.loadDraught,
        });
        if (row.homePort) {
          this.getDicDate(row);
        }
      },
      async getDicDate(row) {
        let codeP = parseInt(row.homePort[0]);
        let code = parseInt(row.homePort[1]);
        let res = await $api.dict.get("searchDic", {
          parentcode: codeP
        });
        if (res.status === 1) {
          res.data.map(i => {
            if (i.dictCode === code) {
              this.$set(this.formData, 'homePort', i.dictText);
            }
          })
        }
      },
      async check() {
        const errMap = await this.$refs.ship.validate().catch(errMap => errMap);
        if (errMap) {
          this.$emit("setParams", false);
          return
        }
        this.setParams();
      },
      setParams() {
        // 过滤参数
        let obj = {
          deadweight: this.formData.deadweight,
          homePort: this.formData.homePort,
          shipType: this.formData.shipType,
          shipLengthWidth: this.formData.shipLengthWidth,
          totalNetWeight: this.formData.totalNetWeight,
          loadDraught: this.formData.loadDraught,
        };
        this.$emit("setParams", obj);
      },
      clearValidate() {
        this.$refs.ship.clearValidate();
      },
      reset() {
        this.formData = {
          deadweight: null,
          homePort: null,
          shipType: null,
          shipLengthWidth: null,
          totalNetWeight: null,
          loadDraught: null,
        };
        this.clearValidate();
      }
    }
  };
</script>

<style scoped>

</style>